import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, apiErr } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/Brand";

export default function Register() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ organization_name: "", name: "", email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/register", form);
      login(data.token, data.user);
      toast.success("Account created");
      nav("/app");
    } catch (err) {
      toast.error(apiErr(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-900 px-4 py-10 font-body">
      <div className="w-full max-w-md rounded-2xl bg-white p-8 shadow-2xl">
        <Link to="/" className="mb-6 flex justify-center"><Logo className="h-20" /></Link>
        <h1 className="text-center font-display text-2xl font-bold uppercase tracking-tight text-slate-900">Create your account</h1>
        <p className="mt-1 text-center text-sm text-slate-500">Set up your property management organization</p>
        <form onSubmit={submit} className="mt-6 space-y-4">
          {[
            { k: "organization_name", label: "Organization / Company name", type: "text", ph: "Summit Property Management" },
            { k: "name", label: "Your name", type: "text", ph: "Jordan Smith" },
            { k: "email", label: "Work email", type: "email", ph: "you@company.com" },
            { k: "password", label: "Password (min 6 chars)", type: "password", ph: "••••••••" },
          ].map((f) => (
            <div key={f.k}>
              <label className="mb-1 block text-sm font-semibold text-slate-700">{f.label}</label>
              <input data-testid={`register-${f.k}-input`} type={f.type} required placeholder={f.ph} value={form[f.k]} onChange={set(f.k)}
                className="w-full rounded-lg border border-slate-300 px-4 py-3 text-sm outline-none focus:border-blue-600 focus:ring-2 focus:ring-blue-100" />
            </div>
          ))}
          <button data-testid="register-submit-btn" disabled={loading}
            className="w-full rounded-lg bg-blue-600 px-4 py-3 font-semibold text-white hover:bg-blue-700 disabled:opacity-60">
            {loading ? "Creating..." : "Create account & start free"}
          </button>
        </form>
        <p className="mt-6 text-center text-sm text-slate-500">
          Already have an account? <Link to="/login" data-testid="to-login-link" className="font-semibold text-blue-600">Sign in</Link>
        </p>
      </div>
    </div>
  );
}
